import $ from 'jquery';
import { fromEvent } from 'rxjs';
import { tap, throttleTime } from 'rxjs/operators';
import singletonModel from '../model/singletonModel';
import { FullScreenSequence } from '../control/fullScreenSequence';
import { isDefined, truthy, falsy } from '../util/util';

export class TransitionController {
    constructor(options = null) {
        const _ = this;

        _.option = $.extend(
            {
                emitter: null,
                pages: [],
                d1: 0
            },
            options
        );

        _.model = singletonModel.getInstance();

        _.emitter = _.option.emitter;

        _.$window = $(window);
        _.$body = $('body');

        _.pages = _.option.pages || [];
        _.curPage = _.getPage(_.option.d1);

        _.wheel$ = fromEvent(document.body, 'mousewheel', { passive: false });
        _.subscribeWheel = null;

        _.fullscreenSequence = null;

        _.isEnable = false;
    }

    setEnable(flag = false) {
        const _ = this;

        _.isEnable = flag;

        return _;
    }

    init(obj = null) {
        const _ = this;

        _.subscribeWheel = _.wheel$
            .pipe(
                tap(evt => {
                    if (falsy(_.model.isEnableMouseWheel)) {
                        evt.preventDefault();
                    }
                }),
                throttleTime(500)
            )
            .subscribe(evt => {
                if (falsy(_.model.isEnableMouseWheel)) {
                    evt.preventDefault();
                    return;
                }
                if(_.model.isShowBodyFixedLayer) return;
                if (truthy(_.isEnable)) {
                    evt.wheelDelta < 0
                        ? _.mouseWheelDown(evt)
                        : _.mouseWheelUp(evt);
                }
            });

        _.fullscreenSequence = new FullScreenSequence({
            $wrap: $('.wrap-canvas'),
            spriteObj: {
                img: $('.sprite-img').get(0),
                width: 600,
                height: 344,
                frameNum: 22,
                fps: 20,
                isLoop: false
            },
            emitter: _.emitter
        }).init();

        return _;
    }

    mouseWheelDown(evt) {
        console.log('mouseWheelDown');
        const _ = this,
            depthObj = _.model.pageIndexObj,
            curDepth1 = depthObj.d1,
            curPage = _.getPage(curDepth1),
            nextPage = _.getPage(curDepth1 + 1);

        if (curPage.getHeight() <= window.innerHeight + _.$window.scrollTop()) {
            if (nextPage) {
                evt.preventDefault();

                _.switchPage(curDepth1 + 1, true);
            }
        } else {
            console.log('scroll contents');
            // scroll contents
        }
    }

    mouseWheelUp(evt) {
        const _ = this,
            depthObj = _.model.pageIndexObj,
            curDepth1 = depthObj.d1,
            // curPage = _.getPage(curDepth1),
            prevPage = _.getPage(curDepth1 - 1);

        if (_.$window.scrollTop() <= 0) {
            if (prevPage) {
                evt.preventDefault();

                _.switchPage(curDepth1 - 1, true);
            }
        } else {
            console.log('scroll contents');
            // scroll contents
        }
    }

    // show page with sequence motion
    switchPage(index, isPlaySequence = false) {
        const _ = this;

        if (_.getPage(index)) {
            _.model.isEnableMouseWheel = false;

            // emit depth1 index
            _.emitter.emit('SWITCH', {
                d1: index
            });

            // enter/exit page's scene
            _.pages.map(page => page.exit().hide());

            _.curPage = _.getPage(index);
            _.curPage.show().enter();

            // restart fullscreen sequence animation
            if (truthy(isPlaySequence)) _.fullscreenSequence.restart();
        }

        return _;
    }

    showAllPages() {
        const _ = this;

        _.pages.map(page => page.show());

        return _;
    }

    getPage(index) {
        const page = this.pages[index - 1];
        return isDefined(page) ? page : null;
    }

    destroy(obj = null) {
        const _ = this;

        _.subscribeWheel.unsubscribe();
        _.subscribeWheel = null;
        // _.$body.off('mousewheel', _.eventHandlers.wheel);

        return _;
    }
}
